
const items = {
    draft: 'draftSaved'
}

class LocalStorage {
    static setLocalDraft = ({isFinished, draftId, draft}) => localStorage.setItem(
        items.draft,
        JSON.stringify({
            isFinished,
            draftId,
            draft
        })
    );

    static getLocalDraft = () => {
        if (!localStorage.getItem(items.draft)) return null;
        return JSON.parse(localStorage.getItem(items.draft));
    }

    static getDraftFromLocalDraft = () => {
        const localDraft = this.getLocalDraft();
        
        if(!localDraft) return null;

        return localDraft.draft;
    }

    static clearLocalDraft = () => localStorage.removeItem(items.draft);
}

export default LocalStorage;